// Textos dos Documentos da Farm (02/11/2026), coletados por glob em
// core/i18n/messages.ts. As pastas têm o rótulo curto, no plural, para caber no
// cartão; o tipo tem o nome inteiro, para a ficha e a célula.
const pt = {
  'farm.documentos.titulo': 'Documentos',
  'farm.documentos.ajuda': 'Cada documento guarda todas as versões. A mais recente é a vigente e aparece na lista; as anteriores ficam no histórico. A vigência alimenta o chip de prazo, que avisa 60 dias antes de vencer. Arquivos em PDF, imagem, DOCX, XLSX ou KML, até 50 MB.',
  'farm.documentos.busca': 'Buscar por título, parte ou arquivo',
  'farm.documentos.semResultado': 'Nada para mostrar com estes filtros',
  'farm.documentos.novo': 'Novo documento',
  'farm.documentos.novaMatricula': 'Nova matrícula',
  'farm.documentos.todos': 'Todos',
  'farm.documentos.todas': 'Todas',
  'farm.documentos.todasAsPastas': 'Todas as pastas',
  'farm.documentos.abrirEmDocumentos': 'Ver em Documentos',
  'farm.documentos.imovelOuFundo': 'Imóvel ou fundo',
  'farm.documentos.imovel': 'Imóvel',
  'farm.documentos.fundo': 'Fundo',
  'farm.documentos.atencaoN': '{{n}} a vencer',

  'farm.documentos.col.documento': 'Documento',
  'farm.documentos.col.versao': 'Versão vigente',
  'farm.documentos.col.vigencia': 'Vigência',
  'farm.documentos.col.valor': 'Valor',
  'farm.documentos.col.acoes': 'Ações',

  'farm.documentos.novaVersao': 'Nova versão',
  'farm.documentos.vigencia': 'Vigência',
  'farm.documentos.baixar': 'Baixar',
  'farm.documentos.historico': 'Histórico de versões',
  'farm.documentos.abrir': 'Abrir',
  'farm.documentos.fechar': 'Fechar',
  'farm.documentos.apagar': 'Apagar',

  'farm.documentos.versaoN': 'Versão {{n}}',
  'farm.documentos.vigente': 'Vigente',
  'farm.documentos.enviadaEm': 'Enviada em',
  'farm.documentos.semVigencia': 'Sem vigência',
  'farm.documentos.desde': 'Desde {{data}}',
  'farm.documentos.ate': 'Até {{data}}',
  'farm.documentos.periodo': '{{de}} a {{ate}}',
  'farm.documentos.resumo': 'SHA {{sha}}',
  'farm.documentos.versoesTotal': 'Versões {{n}}',

  'farm.documentos.prazo.vencido': 'Vencidos',
  'farm.documentos.prazo.proximo': 'Vencem em 60 dias',
  'farm.documentos.prazo.em_dia': 'Em dia',
  'farm.documentos.prazo.sem_prazo': 'Sem vigência',

  'farm.documentos.pasta': 'Pasta',
  'farm.documentos.partes': 'Partes',
  'farm.documentos.partesExemplo': 'Separe as partes por vírgula',
  'farm.documentos.valorAnual': 'Valor anual',
  'farm.documentos.observacoes': 'Observações',
  'farm.documentos.campoTitulo': 'Título',
  'farm.documentos.numeroMatricula': 'Número da matrícula',
  'farm.documentos.tituloMatricula': 'Matrícula {{numero}}',
  'farm.documentos.cartorio': 'Cartório',
  'farm.documentos.areaHa': 'Área em hectares',
  'farm.documentos.proprietario': 'Proprietário',
  'farm.documentos.inicio': 'Início',
  'farm.documentos.fim': 'Fim',
  'farm.documentos.secao.identificacao': 'Identificação',
  'farm.documentos.secao.vigencia': 'Vigência e valor',
  'farm.documentos.secao.arquivo': 'Arquivo',

  'farm.documentos.arquivo': 'Arquivo',
  'farm.documentos.soltarArquivo': 'Solte o arquivo aqui ou clique para escolher',
  'farm.documentos.formatosAceitos': 'PDF, imagem, DOCX, XLSX ou KML até 50 MB',
  'farm.documentos.trocarArquivo': 'Tirar o arquivo',
  'farm.documentos.escolhaArquivo': 'Escolha o arquivo',
  'farm.documentos.nota': 'Nota da versão',
  'farm.documentos.notaExemplo': 'Inteiro teor atualizado',
  'farm.documentos.enviar': 'Enviar',
  'farm.documentos.novaVersaoDe': 'Nova versão de {{titulo}}',
  'farm.documentos.vigenteHoje': 'Hoje vale a versão {{n}}, {{nome}}. A nova passa a ser a vigente.',
  'farm.documentos.vigenciaDe': 'Vigência de {{titulo}}',
  'farm.documentos.fimAntesDoInicio': 'O fim vem depois do início',

  'farm.documentos.recusa.extensao': 'Formato não aceito. Envie PDF, imagem, DOCX, XLSX ou KML.',
  'farm.documentos.recusa.legado': 'Formato antigo do Office. Salve como DOCX ou XLSX e envie de novo.',
  'farm.documentos.recusa.tamanho': 'O arquivo passa de 50 MB.',
  'farm.documentos.recusa.vazio': 'O arquivo está vazio.',
  'farm.documentos.recusa.tipo': 'O conteúdo não confere com a extensão do arquivo.',

  'farm.documentos.erro.tipo': 'Escolha a pasta',
  'farm.documentos.erro.dono': 'Escolha o imóvel ou o fundo',
  'farm.documentos.erro.titulo': 'Informe o título',
  'farm.documentos.erro.numero': 'Informe o número',

  'farm.documentos.versaoEnviada': 'Versão enviada',
  'farm.documentos.vigenciaSalva': 'Vigência salva',
  'farm.documentos.documentoCriado': 'Documento criado',
  'farm.documentos.versaoApagada': 'Versão apagada',
  'farm.documentos.apagarVersao': 'Apagar versão',
  'farm.documentos.apagarVersaoTitulo': 'Apagar a versão {{n}}?',
  'farm.documentos.apagarVersaoTexto': 'O arquivo {{nome}} sai do histórico. A versão vigente continua a mesma.',

  'farm.documentos.tipo.matricula': 'Matrícula',
  'farm.documentos.tipo.car': 'CAR',
  'farm.documentos.tipo.contrato_arrendamento': 'Contrato de arrendamento',
  'farm.documentos.tipo.contrato_boitel': 'Contrato do boitel',
  'farm.documentos.tipo.licenca_ambiental': 'Licença ambiental',
  'farm.documentos.tipo.outorga': 'Outorga',
  'farm.documentos.tipo.itr': 'ITR',
  'farm.documentos.tipo.escritura': 'Escritura',
  'farm.documentos.tipo.certidao': 'Certidão',
  'farm.documentos.tipo.outro': 'Outro',

  'farm.documentos.pasta.matricula': 'Matrículas',
  'farm.documentos.pasta.car': 'CAR',
  'farm.documentos.pasta.contrato_arrendamento': 'Arrendamentos',
  'farm.documentos.pasta.contrato_boitel': 'Boitel',
  'farm.documentos.pasta.licenca_ambiental': 'Licenças',
  'farm.documentos.pasta.outorga': 'Outorgas',
  'farm.documentos.pasta.itr': 'ITR',
  'farm.documentos.pasta.escritura': 'Escrituras',
  'farm.documentos.pasta.certidao': 'Certidões',
  'farm.documentos.pasta.outro': 'Outros',
}

const en: typeof pt = {
  'farm.documentos.titulo': 'Documents',
  'farm.documentos.ajuda': 'Each document keeps every version. The latest one is current and shows in the list; earlier ones stay in the history. The validity feeds the deadline chip, which warns 60 days before expiry. Files in PDF, image, DOCX, XLSX or KML, up to 50 MB.',
  'farm.documentos.busca': 'Search by title, party or file',
  'farm.documentos.semResultado': 'Nothing to show with these filters',
  'farm.documentos.novo': 'New document',
  'farm.documentos.novaMatricula': 'New title deed',
  'farm.documentos.todos': 'All',
  'farm.documentos.todas': 'All',
  'farm.documentos.todasAsPastas': 'All folders',
  'farm.documentos.abrirEmDocumentos': 'See in Documents',
  'farm.documentos.imovelOuFundo': 'Property or fund',
  'farm.documentos.imovel': 'Property',
  'farm.documentos.fundo': 'Fund',
  'farm.documentos.atencaoN': '{{n}} expiring',

  'farm.documentos.col.documento': 'Document',
  'farm.documentos.col.versao': 'Current version',
  'farm.documentos.col.vigencia': 'Validity',
  'farm.documentos.col.valor': 'Value',
  'farm.documentos.col.acoes': 'Actions',

  'farm.documentos.novaVersao': 'New version',
  'farm.documentos.vigencia': 'Validity',
  'farm.documentos.baixar': 'Download',
  'farm.documentos.historico': 'Version history',
  'farm.documentos.abrir': 'Open',
  'farm.documentos.fechar': 'Close',
  'farm.documentos.apagar': 'Delete',

  'farm.documentos.versaoN': 'Version {{n}}',
  'farm.documentos.vigente': 'Current',
  'farm.documentos.enviadaEm': 'Uploaded on',
  'farm.documentos.semVigencia': 'No validity',
  'farm.documentos.desde': 'Since {{data}}',
  'farm.documentos.ate': 'Until {{data}}',
  'farm.documentos.periodo': '{{de}} to {{ate}}',
  'farm.documentos.resumo': 'SHA {{sha}}',
  'farm.documentos.versoesTotal': 'Versions {{n}}',

  'farm.documentos.prazo.vencido': 'Expired',
  'farm.documentos.prazo.proximo': 'Expire in 60 days',
  'farm.documentos.prazo.em_dia': 'Up to date',
  'farm.documentos.prazo.sem_prazo': 'No validity',

  'farm.documentos.pasta': 'Folder',
  'farm.documentos.partes': 'Parties',
  'farm.documentos.partesExemplo': 'Separate the parties with commas',
  'farm.documentos.valorAnual': 'Annual value',
  'farm.documentos.observacoes': 'Notes',
  'farm.documentos.campoTitulo': 'Title',
  'farm.documentos.numeroMatricula': 'Title deed number',
  'farm.documentos.tituloMatricula': 'Title deed {{numero}}',
  'farm.documentos.cartorio': 'Registry office',
  'farm.documentos.areaHa': 'Area in hectares',
  'farm.documentos.proprietario': 'Owner',
  'farm.documentos.inicio': 'Start',
  'farm.documentos.fim': 'End',
  'farm.documentos.secao.identificacao': 'Identification',
  'farm.documentos.secao.vigencia': 'Validity and value',
  'farm.documentos.secao.arquivo': 'File',

  'farm.documentos.arquivo': 'File',
  'farm.documentos.soltarArquivo': 'Drop the file here or click to choose',
  'farm.documentos.formatosAceitos': 'PDF, image, DOCX, XLSX or KML up to 50 MB',
  'farm.documentos.trocarArquivo': 'Remove the file',
  'farm.documentos.escolhaArquivo': 'Choose the file',
  'farm.documentos.nota': 'Version note',
  'farm.documentos.notaExemplo': 'Updated full record',
  'farm.documentos.enviar': 'Upload',
  'farm.documentos.novaVersaoDe': 'New version of {{titulo}}',
  'farm.documentos.vigenteHoje': 'Version {{n}}, {{nome}}, is current today. The new one becomes current.',
  'farm.documentos.vigenciaDe': 'Validity of {{titulo}}',
  'farm.documentos.fimAntesDoInicio': 'The end comes after the start',

  'farm.documentos.recusa.extensao': 'Format not accepted. Upload PDF, image, DOCX, XLSX or KML.',
  'farm.documentos.recusa.legado': 'Old Office format. Save as DOCX or XLSX and upload again.',
  'farm.documentos.recusa.tamanho': 'The file is larger than 50 MB.',
  'farm.documentos.recusa.vazio': 'The file is empty.',
  'farm.documentos.recusa.tipo': 'The content does not match the file extension.',

  'farm.documentos.erro.tipo': 'Choose the folder',
  'farm.documentos.erro.dono': 'Choose the property or the fund',
  'farm.documentos.erro.titulo': 'Enter the title',
  'farm.documentos.erro.numero': 'Enter the number',

  'farm.documentos.versaoEnviada': 'Version uploaded',
  'farm.documentos.vigenciaSalva': 'Validity saved',
  'farm.documentos.documentoCriado': 'Document created',
  'farm.documentos.versaoApagada': 'Version deleted',
  'farm.documentos.apagarVersao': 'Delete version',
  'farm.documentos.apagarVersaoTitulo': 'Delete version {{n}}?',
  'farm.documentos.apagarVersaoTexto': 'The file {{nome}} leaves the history. The current version stays the same.',

  'farm.documentos.tipo.matricula': 'Title deed',
  'farm.documentos.tipo.car': 'Rural environmental registry',
  'farm.documentos.tipo.contrato_arrendamento': 'Lease agreement',
  'farm.documentos.tipo.contrato_boitel': 'Feedlot agreement',
  'farm.documentos.tipo.licenca_ambiental': 'Environmental license',
  'farm.documentos.tipo.outorga': 'Water right',
  'farm.documentos.tipo.itr': 'Rural land tax',
  'farm.documentos.tipo.escritura': 'Deed',
  'farm.documentos.tipo.certidao': 'Certificate',
  'farm.documentos.tipo.outro': 'Other',

  'farm.documentos.pasta.matricula': 'Title deeds',
  'farm.documentos.pasta.car': 'CAR',
  'farm.documentos.pasta.contrato_arrendamento': 'Leases',
  'farm.documentos.pasta.contrato_boitel': 'Feedlot',
  'farm.documentos.pasta.licenca_ambiental': 'Licenses',
  'farm.documentos.pasta.outorga': 'Water rights',
  'farm.documentos.pasta.itr': 'ITR',
  'farm.documentos.pasta.escritura': 'Deeds',
  'farm.documentos.pasta.certidao': 'Certificates',
  'farm.documentos.pasta.outro': 'Others',
}

const es: typeof pt = {
  'farm.documentos.titulo': 'Documentos',
  'farm.documentos.ajuda': 'Cada documento guarda todas las versiones. La más reciente es la vigente y aparece en la lista; las anteriores quedan en el historial. La vigencia alimenta el chip de plazo, que avisa 60 días antes del vencimiento. Archivos en PDF, imagen, DOCX, XLSX o KML, hasta 50 MB.',
  'farm.documentos.busca': 'Buscar por título, parte o archivo',
  'farm.documentos.semResultado': 'Nada para mostrar con estos filtros',
  'farm.documentos.novo': 'Nuevo documento',
  'farm.documentos.novaMatricula': 'Nueva matrícula',
  'farm.documentos.todos': 'Todos',
  'farm.documentos.todas': 'Todas',
  'farm.documentos.todasAsPastas': 'Todas las carpetas',
  'farm.documentos.abrirEmDocumentos': 'Ver en Documentos',
  'farm.documentos.imovelOuFundo': 'Inmueble o fondo',
  'farm.documentos.imovel': 'Inmueble',
  'farm.documentos.fundo': 'Fondo',
  'farm.documentos.atencaoN': '{{n}} por vencer',

  'farm.documentos.col.documento': 'Documento',
  'farm.documentos.col.versao': 'Versión vigente',
  'farm.documentos.col.vigencia': 'Vigencia',
  'farm.documentos.col.valor': 'Valor',
  'farm.documentos.col.acoes': 'Acciones',

  'farm.documentos.novaVersao': 'Nueva versión',
  'farm.documentos.vigencia': 'Vigencia',
  'farm.documentos.baixar': 'Descargar',
  'farm.documentos.historico': 'Historial de versiones',
  'farm.documentos.abrir': 'Abrir',
  'farm.documentos.fechar': 'Cerrar',
  'farm.documentos.apagar': 'Borrar',

  'farm.documentos.versaoN': 'Versión {{n}}',
  'farm.documentos.vigente': 'Vigente',
  'farm.documentos.enviadaEm': 'Enviada el',
  'farm.documentos.semVigencia': 'Sin vigencia',
  'farm.documentos.desde': 'Desde {{data}}',
  'farm.documentos.ate': 'Hasta {{data}}',
  'farm.documentos.periodo': '{{de}} a {{ate}}',
  'farm.documentos.resumo': 'SHA {{sha}}',
  'farm.documentos.versoesTotal': 'Versiones {{n}}',

  'farm.documentos.prazo.vencido': 'Vencidos',
  'farm.documentos.prazo.proximo': 'Vencen en 60 días',
  'farm.documentos.prazo.em_dia': 'Al día',
  'farm.documentos.prazo.sem_prazo': 'Sin vigencia',

  'farm.documentos.pasta': 'Carpeta',
  'farm.documentos.partes': 'Partes',
  'farm.documentos.partesExemplo': 'Separe las partes con comas',
  'farm.documentos.valorAnual': 'Valor anual',
  'farm.documentos.observacoes': 'Observaciones',
  'farm.documentos.campoTitulo': 'Título',
  'farm.documentos.numeroMatricula': 'Número de matrícula',
  'farm.documentos.tituloMatricula': 'Matrícula {{numero}}',
  'farm.documentos.cartorio': 'Registro',
  'farm.documentos.areaHa': 'Área en hectáreas',
  'farm.documentos.proprietario': 'Propietario',
  'farm.documentos.inicio': 'Inicio',
  'farm.documentos.fim': 'Fin',
  'farm.documentos.secao.identificacao': 'Identificación',
  'farm.documentos.secao.vigencia': 'Vigencia y valor',
  'farm.documentos.secao.arquivo': 'Archivo',

  'farm.documentos.arquivo': 'Archivo',
  'farm.documentos.soltarArquivo': 'Suelte el archivo aquí o haga clic para elegir',
  'farm.documentos.formatosAceitos': 'PDF, imagen, DOCX, XLSX o KML hasta 50 MB',
  'farm.documentos.trocarArquivo': 'Quitar el archivo',
  'farm.documentos.escolhaArquivo': 'Elija el archivo',
  'farm.documentos.nota': 'Nota de la versión',
  'farm.documentos.notaExemplo': 'Certificado íntegro actualizado',
  'farm.documentos.enviar': 'Enviar',
  'farm.documentos.novaVersaoDe': 'Nueva versión de {{titulo}}',
  'farm.documentos.vigenteHoje': 'Hoy vale la versión {{n}}, {{nome}}. La nueva pasa a ser la vigente.',
  'farm.documentos.vigenciaDe': 'Vigencia de {{titulo}}',
  'farm.documentos.fimAntesDoInicio': 'El fin va después del inicio',

  'farm.documentos.recusa.extensao': 'Formato no aceptado. Envíe PDF, imagen, DOCX, XLSX o KML.',
  'farm.documentos.recusa.legado': 'Formato antiguo de Office. Guarde como DOCX o XLSX y envíe de nuevo.',
  'farm.documentos.recusa.tamanho': 'El archivo supera los 50 MB.',
  'farm.documentos.recusa.vazio': 'El archivo está vacío.',
  'farm.documentos.recusa.tipo': 'El contenido no coincide con la extensión del archivo.',

  'farm.documentos.erro.tipo': 'Elija la carpeta',
  'farm.documentos.erro.dono': 'Elija el inmueble o el fondo',
  'farm.documentos.erro.titulo': 'Informe el título',
  'farm.documentos.erro.numero': 'Informe el número',

  'farm.documentos.versaoEnviada': 'Versión enviada',
  'farm.documentos.vigenciaSalva': 'Vigencia guardada',
  'farm.documentos.documentoCriado': 'Documento creado',
  'farm.documentos.versaoApagada': 'Versión borrada',
  'farm.documentos.apagarVersao': 'Borrar versión',
  'farm.documentos.apagarVersaoTitulo': '¿Borrar la versión {{n}}?',
  'farm.documentos.apagarVersaoTexto': 'El archivo {{nome}} sale del historial. La versión vigente sigue igual.',

  'farm.documentos.tipo.matricula': 'Matrícula',
  'farm.documentos.tipo.car': 'Registro ambiental rural',
  'farm.documentos.tipo.contrato_arrendamento': 'Contrato de arrendamiento',
  'farm.documentos.tipo.contrato_boitel': 'Contrato de hotelería de ganado',
  'farm.documentos.tipo.licenca_ambiental': 'Licencia ambiental',
  'farm.documentos.tipo.outorga': 'Concesión de agua',
  'farm.documentos.tipo.itr': 'Impuesto territorial rural',
  'farm.documentos.tipo.escritura': 'Escritura',
  'farm.documentos.tipo.certidao': 'Certificado',
  'farm.documentos.tipo.outro': 'Otro',

  'farm.documentos.pasta.matricula': 'Matrículas',
  'farm.documentos.pasta.car': 'CAR',
  'farm.documentos.pasta.contrato_arrendamento': 'Arrendamientos',
  'farm.documentos.pasta.contrato_boitel': 'Hotelería',
  'farm.documentos.pasta.licenca_ambiental': 'Licencias',
  'farm.documentos.pasta.outorga': 'Concesiones',
  'farm.documentos.pasta.itr': 'ITR',
  'farm.documentos.pasta.escritura': 'Escrituras',
  'farm.documentos.pasta.certidao': 'Certificados',
  'farm.documentos.pasta.outro': 'Otros',
}

export default { pt, en, es }
